import { useQuery } from '@tanstack/react-query';
import { apiClient, ProductCategory, useAuthStore } from '@dukene/shared';

interface UseCategoriesOptions {
  search?: string;
  page?: number;
  limit?: number;
}

export function useCategories(options: UseCategoriesOptions = {}) {
  const { search, page = 1, limit = 50 } = options;
  const activeStoreId = useAuthStore((state) => state.activeStoreId);

  return useQuery<ProductCategory[]>({
    queryKey: ['merchant-categories', activeStoreId, search, page, limit],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      params.append('page', page.toString());
      params.append('limit', limit.toString());
      
      // apiClient.get already unwraps the 'data' field, so we get the array directly
      return apiClient.get<ProductCategory[]>(`/products/categories?${params}`);
    },
    enabled: !!activeStoreId,
  });
}
